module.exports = __webpack_public_path__ + "assets/img/result-bg1.3d6a598b.png";